import { gql, useMutation } from '@apollo/client';

import type {
  UpdateCaregiverRelationshipMutation,
  UpdateCaregiverRelationshipMutationVariables,
} from './__generated__/useUpdateCaregiverRelationship.gql';

const UPDATE_CAREGIVER_RELATIONSHIP = gql`
  mutation UpdateCaregiverRelationship($input: UpdateCaregiverRelationshipInput!) {
    updateCaregiverRelationship(input: $input) {
      id
      relationship
      isStep
      isInLaw
      livesWithCaregiver
    }
  }
`;

/**
 * Updates the caregiver-edge fields (`relationship`, `isStep`, `isInLaw`,
 * `relationshipOther`, `livesWithCaregiver`) for an existing
 * `CaregiverRelationship` row. Used by `DependantEntryStep` in edit mode
 * alongside `useUpdateDependant` — the dependant fields and the relationship
 * fields live on separate rows server-side.
 *
 * Cache normalization handles the read-side update: the mutation response
 * carries the row id + fields, so any query selecting the same
 * `(CaregiverRelationship, id)` picks them up.
 */
export const useUpdateCaregiverRelationship = () => {
  return useMutation<UpdateCaregiverRelationshipMutation, UpdateCaregiverRelationshipMutationVariables>(
    UPDATE_CAREGIVER_RELATIONSHIP
  );
};
